module.exports = __webpack_public_path__ + "assets/fonts/Gordita-Regular.6d2e30b1bc279342539a3fcfe310d665.woff";